{
  "name": "36-2/17-Schisma MT (based on Helmholtz)",
  "description": "36-tone scale tempering the perfect fifth narrow by 2/17 Schisma (by dividing the ratio 32805/32768, or ca. 2 cents, representing the difference between 8 2:3 perfect fifths and a 4:5, into very small parts). 8 perfect fifths produce a 4:5 major third less 1/17 schisma and nine perfect fifths produce a 5:6 minor third less 1/17 schisma. Based on Hermann von Helmholtz’s 24-note harmonium tuning and Gioseffo Zarlino’s 2/7 Syntonic Comma Meantone.",
  "scale": [
    "20.70181633",
    "70.67242686",
    "91.3742432",
    "112.0760595",
    "182.7484864",
    "203.4503027",
    "224.1521191",
    "274.1227296",
    "294.8245459",
    "315.5263622",
    "386.1987891",
    "406.9006054",
    "427.6024218",
    "477.5730323",
    "498.2748486",
    "518.976665",
    "568.9472755",
    "589.6490918",
    "610.3509082",
    "681.023335",
    "701.7251514",
    "722.4269677",
    "772.3975782",
    "793.0993946",
    "813.8012109",
    "884.4736378",
    "905.1754541",
    "925.8772704",
    "975.8478809",
    "996.5496973",
    "1017.251514",
    "1087.92394",
    "1108.625757",
    "1129.327573",
    "1179.298184",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "35-MT_Helmholtz",
  "built_in_group": "Extended Meantone",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "C",
    "C",
    "C",
    "C D",
    "D",
    "D",
    "D",
    "D",
    "D E",
    "E",
    "E",
    "E",
    "E",
    "E F",
    "F",
    "F",
    "F",
    "F",
    "F G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A B",
    "B",
    "B",
    "B",
    "B",
    "B C"
  ],
  "note_colors": [
    "#ffc2c2",
    "#dee2da",
    "#fceec5",
    "#fffae5",
    "#d0d0d7",
    "#fffae5",
    "#ffffff",
    "#dee2da",
    "#fceec5",
    "#e4e2dd",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#dee2da",
    "#e0dbc2",
    "#ffffff",
    "#dee2da",
    "#fceec5",
    "#fffae5",
    "#d0d0d7",
    "#fffae5",
    "#ffffff",
    "#dee2da",
    "#fceec5",
    "#fffae5",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#dee2da",
    "#fceec5",
    "#e4e2dd",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#dee2da",
    "#e0dbc2"
  ],
  "equivSteps": 36,
  "fundamental": 440,
  "reference_degree": 27,
  "center_degree": 0,
  "rSteps": 6,
  "drSteps": 5,
  "hexSize": 42,
  "rotation": -21.2
}
